import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import DramaCard from '@/components/feature/DramaCard';
import { dramaCategories, getDramasByCategory } from '@/mocks/dramas';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'all';
  const currentCategory = dramaCategories.find(c => c.slug === currentSlug) || dramaCategories[0];
  const categoryDramas = getDramasByCategory(currentSlug);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        {/* Header */}
        <section className="bg-background-50 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '分类浏览' },
                { label: currentCategory.name },
              ]}
            />
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-4">
              {currentCategory.name}
            </h1>
            <p className="text-sm text-foreground-500 mt-1">
              共 {categoryDramas.length} 部剧集
            </p>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="bg-background-50 border-b border-background-200/70 sticky top-16 z-30">
          <div className="w-full px-4 md:px-6">
            <div className="flex items-center gap-2 py-3 overflow-x-auto scrollbar-hide">
              {dramaCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                    currentSlug === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200 hover:text-primary-500'
                  }`}
                >
                  {cat.slug === 'hot' && <i className="ri-fire-line text-sm"></i>}
                  {cat.slug === 'chinese' && <i className="ri-flag-2-line text-sm"></i>}
                  {cat.slug === 'korean' && <i className="ri-kakao-talk-line text-sm"></i>}
                  {cat.slug === 'american' && <i className="ri-earth-line text-sm"></i>}
                  {cat.slug === 'japanese' && <i className="ri-sun-line text-sm"></i>}
                  {cat.slug === 'thai' && <i className="ri-palette-line text-sm"></i>}
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Drama Grid */}
        <section className="bg-background-50 py-10 md:py-14">
          <div className="w-full px-4 md:px-6">
            {categoryDramas.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
                {categoryDramas.map((drama) => (
                  <DramaCard key={drama.id} drama={drama} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
                  <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500 text-sm">该分类暂无剧集，敬请期待</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}